import { AxiosInstance } from "axios";
import axiosHelper from "../axiosHelper";
import LinkedLabelValuePair from "@/models/LinkedLabelValuePair";

export default class ItemsGroupApiHelper {

	_url: string = '/api/itemsgroups';
	_jwt: string;
	getGroupsTreeHttpClient: AxiosInstance;

	constructor(jwt: string) {
		this._jwt = jwt;
		this.getGroupsTreeHttpClient = axiosHelper.createInstance(jwt);
	}

	async addGroupAsync(name: string, descr: string | null, parentId: number | null): Promise<boolean> {
		try {	
			const addGroupsHttpClient = axiosHelper.createInstance(this._jwt);		
			await addGroupsHttpClient.post(`${this._url}`, {
				name: name,
				description: descr,
				parentGroupId: parentId
			});
			return true;
		} catch (e: any) {
			console.error('Error adding new items group', e);
			return false;
		}
	}

	async updateGroupAsync(id: number, name: string, descr: string | null, parentId: number | null): Promise<boolean> {
		try {	
			const addGroupsHttpClient = axiosHelper.createInstance(this._jwt);		
			await addGroupsHttpClient.post(`${this._url}`, {
				id: id,
				name: name,
				description: descr,
				parentGroupId: parentId
			});
			return true;
		} catch (e: any) {
			console.error(`Error updating group #${id}`, e);
			return false;
		}
	}

	async getGroupsTreeAsync(): Promise<Array<LinkedLabelValuePair<string, number>>> {

		const mapGroupsTree = (data: Array<any>): Array<LinkedLabelValuePair<string, number>> => {
			return data.map((g: any) => {
				const group = new LinkedLabelValuePair<string, number>({
					label: g.name,
					value: g.id
				});
				if (!g?.childGroups?.length) {
					group.children = undefined;
				}
				else {
					group.children = mapGroupsTree(g.childGroups);
				}

				return group;
			});
		}

		try {			
			const response = await this.getGroupsTreeHttpClient.get(`${this._url}`);
			if (!response.data?.length) {
				return [];
			}
			return mapGroupsTree(response.data);
		} catch (e: any) {
			console.error('Error loading items groups tree', e);
			return [];
		}
	}

	async deleteGroupAsync(id: number) {
		try {
			const a = axiosHelper.createInstance(this._jwt);
			await a.delete(`${this._url}/${id}`);			
			return true;
		} catch(e) {
			console.error(`Error deleting group #${id}`, e);
			return false;
		}
	}

	async isGroupUniqueAsync(name: string, parentId: number | null): Promise<boolean> {
		try {			
			const addGroupsHttpClient = axiosHelper.createInstance(this._jwt);		
			await addGroupsHttpClient.get(`${this._url}/${name}/${parentId}`);
			return true;			
		} catch (e: any) {
			if (e?.status === 409) {
				return false;
			}
			console.error('Error checking items groups is unique', e);
			return false
		}
	}
}